/**
 *
 * LOGIN
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
import Swal from 'sweetalert2';

import { LOGIN_PHONE_PAGE } from '@/constants/routes';
import Login from '@/scripts/Login/Login';

export default {
  name: 'LoginKeCuHui',

  mixins: [Login],

  data: () => {
    return {
      promiseGetMallGoodQrcode: null,

      addForFreeStatus: 0,

      promiseGetStudentAndTutorInfo: null,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('Mall/Order', {
      ms_order: 'order',
      ms_taobaoOrderResult: 'taobaoOrderResult',
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isNeedAddForFree() {
      return this.$route.query.goodId && this.$route.query.source;
    },

    c_taobaoCodeStatus() {
      return this.ms_order.taobaoCodeStatus;
    },

    c_taobaoResultMessage() {
      if (undefined !== this.c_taobaoCodeStatus) {
        if (1 === this.c_taobaoCodeStatus) {
          return '开课码已使用';
        } else if (2 === this.c_taobaoCodeStatus) {
          return '开课码已失效';
        } else {
          return this.ms_taobaoOrderResult.message;
        }
      } else {
        return '开课码已失效';
      }
    },
  },

  methods: {
    ...mapActions({
      ma_getUserInfo: 'getUserInfo',
      ma_getTutorInfo: 'getTutorInfo',
      ma_logout: 'logout',
    }),

    ...mapActions('Mall/Order', {
      ma_getMallPublicGoodQrcode: 'getMallPublicGoodQrcode',
      ma_mallAddForTaobao: 'mallAddForTaobao',
    }),

    async getMallGoodQrcode() {
      await this.ma_getMallPublicGoodQrcode({
        goodId: this.$route.query.goodId,
        source: this.$route.query.source,
      });
    },

    getStudentAndTutorInfo() {
      this.promiseGetStudentAndTutorInfo = Promise.all([
        this.ma_getUserInfo(),
        this.ma_getTutorInfo(),
      ]);
    },

    addForFreeStatusNextStep() {
      this.addForFreeStatus = 1;
    },

    async addForFree() {
      this.addForFreeStatus = 2;
      try {
        let flagFail = false;
        await this.ma_mallAddForTaobao({
          code: this.$route.query.goodId,
          source: this.$route.query.source,
        });
        if (false === this.ms_taobaoOrderResult.data) {
          flagFail = true;
        }
        if (!flagFail) {
          this.getStudentAndTutorInfo();
          this.addForFreeStatusNextStep();
        } else {
          this.addForFreeStatus = -1;
        }
      } catch (e) {
        this.addForFreeStatus = -1;
      }
    },

    ///
    async afterLogin() {
      if (this.c_isNeedAddForFree) {
        await this.promiseGetMallGoodQrcode;
        await this.addForFree();
        if (1 !== this.addForFreeStatus) {
          await Swal.fire({
            icon: 'warning',
            backdrop: 'static',
            keyboard: false,
            title: '温馨提示',
            text: this.c_taobaoResultMessage,
            confirmButtonColor: '#3085d6',
            confirmButtonText: '确定',
          }).then((result) => {
            if (result.value) {
              this.ma_logout();
              this.push(
                `/login-kecuhui?goodId=${this.$route.query.goodId}&source=${this.$route.query.source}`
              );
            }
          });
          return;
        }
      }
      if (this.mg_userInfo.profile && this.mg_userInfo.profile.mobileValided) {
        this.goToNextPage();
      } else {
        this.$router.push(LOGIN_PHONE_PAGE + this._makeUrlAddParamsAndHash());
      }
    },
  },

  created() {
    if (this.c_isNeedAddForFree) {
      this.promiseGetMallGoodQrcode = this.getMallGoodQrcode();
    }
  },
};
